import { useMutation } from '@tanstack/react-query';
import { useRouter } from 'next/navigation';
import { toast } from 'sonner';

import { createCheckoutSession } from '@/features/orders/api';
import { ApiErrorResponse } from '@/lib/api/types';

export const useCheckoutMutation = () => {
  const router = useRouter();

  return useMutation({
    mutationFn: createCheckoutSession,
    onSuccess: (data) => {
      router.replace(data.url, { scroll: true });
    },
    onError: (error: ApiErrorResponse) => {
      const message =
        error.message ??
        'Failed to create checkout session. Please try again later.';
      toast.error(message);
    },
  });
};
